import { useMutation } from '@tanstack/react-query';

import { downloadFile } from '@shared/helpers';
import { downloadObject } from '@widgets/Files/api/downloadObject';
import { TFolderId } from '@widgets/Files/model/types/folderId.type';

export const useDownloadObject = (folderId: TFolderId | 'default') =>
    useMutation({
        mutationKey: ['downloadObject'],
        mutationFn: () => downloadObject({ folderId }),
        onSuccess: ({ blob, filename }) => {
            downloadFile(blob, filename);
        },
        onError: (err: any) => {
            console.error('Download failed', err);
        },
    });
